import React from 'react';
import { Field, useFormikContext } from 'formik';

import { InputUI, FormErrorUI, FormLabelUI, SelectUI, CheckboxUI } from '../Interface';
import { AreaOption, CategoryOption, SubjectOption, TypeOption } from '../../config/vatCodes';
import PrintTranslationFieldButton from '../PrintTranslation/PrintTranslationFieldButton';
import { PrintTranslationResource } from '../../config/printTranslation';

export const VatCodeFields = ({ viewField, selectedValues, addField }) => {
  const { values, errors, setFieldValue, validateField } = useFormikContext();
  return (
    <div className="grid grid-cols-4 gap-x-4 mx-4 mb-5">
      <div className="md:col-span-2 col-span-4">
        <Field
          type="text"
          name="code"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Áfakulcs" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.code} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.code && values.code !== '' }}
        />
      </div>
      <div className="md:col-span-2 col-span-4">
        <Field
          type="text"
          name="name"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Megnevezés" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.name} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.name && values.name !== '' }}
          InputProps={{
            endAdornment: (
              <PrintTranslationFieldButton
                resourceCode={PrintTranslationResource.VAT_CODE}
                recordKey={selectedValues?.code}
                fieldName="name"
                isEditMode={!viewField && addField}
              />
            ),
          }}
        />
      </div>
      <div className="col-span-4">
        <Field
          type="text"
          name="description"
          as={InputUI}
          fullWidth
          multiline
          minRows={2}
          label={<FormLabelUI text="Leírás" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.description} />}
          disabled={viewField}
          InputLabelProps={{ shrink: Boolean(values.description) }}
        />
      </div>
      <div className="md:col-span-2 col-span-4">
        <Field
          type="number"
          name="percentage"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Százalék" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.percentage} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.percentage && values.percentage !== '' }}
        />
      </div>
      <div className="col-span-4 md:col-span-2">
        <Field
          name="category"
          component={SelectUI}
          fullWidth
          label={<FormLabelUI text="Kategória" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.category} />}
          onChange={(e) => {
            const value = e.target.value;
            setFieldValue('category', value ?? null).then(() => {
              validateField('category');
            });
          }}
          value={values.category ?? ''}
          disabled={viewField}
          option={CategoryOption}
        />
      </div>
      <div className="col-span-4 md:col-span-2">
        <Field
          name="area"
          component={SelectUI}
          fullWidth
          label={<FormLabelUI text="Terület" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.area} />}
          onChange={(e) => {
            const value = e.target.value;
            setFieldValue('area', value ?? null).then(() => {
              validateField('area');
            });
          }}
          value={values.area ?? ''}
          disabled={viewField}
          option={AreaOption}
        />
      </div>
      <div className="col-span-4 md:col-span-2">
        <Field
          name="subject"
          component={SelectUI}
          fullWidth
          label={<FormLabelUI text="Tárgy" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.subject} />}
          onChange={(e) => {
            const value = e.target.value;
            setFieldValue('subject', value ?? null).then(() => {
              validateField('subject');
            });
          }}
          value={values.subject ?? ''}
          disabled={viewField}
          option={SubjectOption}
        />
      </div>
      <div className="col-span-4 md:col-span-2">
        <Field
          name="type"
          component={SelectUI}
          fullWidth
          label={<FormLabelUI text="Áfakulcs típusa" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.type} />}
          onChange={(e) => {
            const value = e.target.value;
            setFieldValue('type', value ?? null).then(() => {
              validateField('type');
            });
          }}
          value={values.type ?? ''}
          disabled={viewField}
          option={TypeOption}
        />
      </div>
      <div className="md:col-span-2 col-span-4">
        <Field
          type="text"
          name="navo"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="NAV Online áfakulcs" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.navo} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.navo && values.navo !== '' }}
        />
      </div>
      <div className="md:col-span-2 col-span-4">
        <Field
          name="active"
          type="checkbox"
          as={CheckboxUI}
          fullWidth
          label={<FormLabelUI text="Aktív" />}
          disabled={viewField}
        />
      </div>
    </div>
  );
};

export default VatCodeFields;
